<template>
  <v-dialog
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
    max-width="500">
    <v-card>
      <v-app-bar flat dark color="primary">
        <v-toolbar-title>Zeitnachweis genehmigen</v-toolbar-title>
      </v-app-bar>
      <v-card>
        <v-card-text>
          Sie möchten diesen Zeitnachweis wirklich genehmigen?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="closeApproveDialog"
          >
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="approveServiceTracking"
          >
            Genehmigen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ApproveServiceTrackingDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      serviceTracking: {
        type: Object,
        default: function () {
          return {
            id: 0
          }
        }
      }
    },
    methods: {
      approveServiceTracking () {
        this.$store.dispatch('approveServiceTracking', this.serviceTracking)
        this.$emit('close')
      },
      closeApproveDialog () {
        this.serviceTracking.approved = false
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ServiceTracking/ApproveServiceTrackingDialog.vue